import { baseUrl } from "./HttpService";

const requestReview = async (path, { body, anonymous = false } = {}) => {
  const headers = {};
  if (!anonymous) headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  if (body) headers["Content-Type"] = "application/json";
  const response = await fetch(`${baseUrl}/ConsultationReview${path}`, {
    method: body ? "POST" : "GET",
    headers,
    cache: "no-store",
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  if (!response.ok) {
    const error = new Error("درخواست انجام نشد. دوباره تلاش کنید.");
    error.status = response.status;
    throw error;
  }
  return response.status === 204 ? null : response.json();
};

export const getSessionReview = (sessionId) => requestReview(`/session/${sessionId}`);
export const createConsultationReview = (sessionId, data) =>
  requestReview(`/session/${sessionId}`, { body: data });
export const createGeneralReview = (data) => requestReview("/general", { body: data });
export const getMyConsultationReviews = () => requestReview("/mine");
export const getPendingConsultationReviews = () => requestReview("/pending");
export const moderateConsultationReview = (id, approve) =>
  requestReview(`/${id}/moderate`, { body: { approve } });
export const getPublicConsultationReviews = (page = 1) =>
  requestReview(`/public?page=${page}&pageSize=6`, { anonymous: true });
